import PropTypes from 'prop-types';
import { useQuery } from 'react-query';

import { getWorkReqeustForm } from 'api';

import Modal from 'components/ui-kit/modal';

import { useApp, useModal } from 'hooks';

import DepositReturn from './deposit-return';
import RequestWorkForm from './form';

// depositReturn is the way back from the payment page ({ kind, token }): the window shows how the payment stands
// instead of the form.
const RequestWorkModal = ({ depositReturn }) => {
  const { portal } = useApp();
  const { hideModal } = useModal();

  const {
    isError, isLoading, isFetching, data,
  } = useQuery(
    ['requestWorkForm', portal?.id],
    getWorkReqeustForm,
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!portal?.id && !depositReturn,
    },
  );

  if (depositReturn) {
    return (
      <Modal isClosable={false}>
        <DepositReturn kind={depositReturn.kind} token={depositReturn.token} onClose={hideModal} />
      </Modal>
    );
  }

  if (isError) {
    return 'Error occured while fetching appointment';
  }

  if (isLoading || isFetching) {
    return 'loader';
  }

  const form = data?.data;

  return (
    <Modal isClosable={false}>
      <RequestWorkForm form={form} />
    </Modal>
  );
};

RequestWorkModal.propTypes = {
  depositReturn: PropTypes.shape({
    kind: PropTypes.oneOf(['success', 'cancel']).isRequired,
    token: PropTypes.string.isRequired,
  }),
};

RequestWorkModal.defaultProps = {
  depositReturn: null,
};

export default RequestWorkModal;
